import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doHandlePusherMessage),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchPusherChannel),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchPusher);

/* eslint-disable no-unused-vars */
import { eventChannel } from 'redux-saga';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import Pusher from 'pusher-js';
import { take, call, fork, put, race, takeEvery } from 'redux-saga/effects';
import { userProfile } from 'redux/saga/entities/bound';
import { updateDevice, videoCompleted } from 'redux/modules/video';
import clientConfig from 'universal-config';
import { errorActionCreator } from 'redux/saga/helpers';
import { VIDEO_CLASS_STATE } from 'constants/video';
export var PUSHER_ERROR = 'PUSHER_ERROR';
export var CLOSE_PUSHER_CHANNEL = 'CLOSE_PUSHER_CHANNEL';
export var INIT_PUSHER_CHANNEL = 'INIT_PUSHER_CHANNEL';
export var HANDLE_PUSHER_MESSAGE = 'HANDLE_PUSHER_MESSAGE';
export var CLASS_END_STATE = 'ENDED';
export var pusherError = errorActionCreator.bind(null, PUSHER_ERROR);
export var closePusherChannel = function closePusherChannel() {
  return {
    type: CLOSE_PUSHER_CHANNEL
  };
};
export var initPusherChannel = function initPusherChannel(channelName) {
  return {
    type: INIT_PUSHER_CHANNEL,
    channelName: channelName
  };
};
export function doInitPusherChannel(channelName) {
  return eventChannel(function (emitter) {
    var config = clientConfig();
    var socket = new Pusher(config.pusher.appKey, {
      cluster: config.pusher.cluster,
      encrypted: true
    });
    var channel = socket.subscribe(channelName);
    channel.bind('leaderboard', function (data) {
      return emitter({
        type: 'HANDLE_PUSHER_MESSAGE',
        data: data
      });
    });
    return function () {
      socket.disconnect();
    };
  });
}
export function doHandlePusherMessage(client, _ref) {
  var data, user, _data$entries, participants, classState, myIndex, payload;

  return regeneratorRuntime.wrap(function doHandlePusherMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data;
          _context.prev = 1;
          _context.next = 4;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 4:
          user = _context.sent;
          _data$entries = data.entries, participants = _data$entries === void 0 ? [] : _data$entries, classState = data.class_state;
          myIndex = participants.findIndex(function (p) {
            return p.user_id === user.id;
          });
          payload = {
            classState: classState,
            leaderboard: {
              participants: participants,
              myIndex: myIndex
            },
            score: myIndex >= 0 ? participants[myIndex].points : 0
          };

          if (data.target_zone) {
            payload.targetZone = data.target_zone;
          }

          if (!(classState === CLASS_END_STATE)) {
            _context.next = 12;
            break;
          }

          _context.next = 12;
          return put(videoCompleted());

        case 12:
          _context.next = 14;
          return put(updateDevice(payload));

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](1);
          _context.next = 20;
          return put(pusherError(_context.t0));

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 16]]);
}
export function watchPusherChannel(client, _ref2) {
  var channelName, channel, _ref3, action, cancel;

  return regeneratorRuntime.wrap(function watchPusherChannel$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          channelName = _ref2.channelName;
          _context2.next = 3;
          return call(doInitPusherChannel, channelName);

        case 3:
          channel = _context2.sent;

        case 4:
          if (!true) {
            _context2.next = 15;
            break;
          }

          _context2.next = 7;
          return race({
            action: take(channel),
            cancel: take(CLOSE_PUSHER_CHANNEL)
          });

        case 7:
          _ref3 = _context2.sent;
          action = _ref3.action;
          cancel = _ref3.cancel;
          _context2.next = 12;
          return put(action);

        case 12:
          if (cancel || action.data.class_state === VIDEO_CLASS_STATE.ENDED) {
            channel.close();
          }

          _context2.next = 4;
          break;

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function watchPusher(client) {
  return regeneratorRuntime.wrap(function watchPusher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, INIT_PUSHER_CHANNEL, watchPusherChannel, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, HANDLE_PUSHER_MESSAGE, doHandlePusherMessage, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}